import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "setup";
import { SquareProps } from "./Square";

const initialState = {
  squares: Array(9).fill(null),
  availableSquares: [0, 1, 2, 3, 4, 5, 6, 7, 8],
  xIsNext: true,
};

export const tictactoeSlice = createSlice({
  name: "tictactoe",
  initialState,
  reducers: {
    selectSquare: (state, action) => {
      const i = action.payload;
      if (calculateWinner(state.squares) || state.squares[i]) {
        return;
      }

      // player turn
      state.squares[i] = "X";
      let removeIndex = state.availableSquares.indexOf(i);
      state.availableSquares.splice(removeIndex, 1);

      if (calculateWinner(state.squares)) {
        return;
      }

      // ai turn
      const randomSquare =
        state.availableSquares[
          Math.round(Math.random() * state.availableSquares.length) % state.availableSquares.length
        ];
      if (randomSquare) {
        state.squares[randomSquare] = "O";
        removeIndex = state.availableSquares.indexOf(randomSquare);
        state.availableSquares.splice(removeIndex, 1);
      }
    },
    restartGame: () => initialState,
  },
});

export function calculateWinner(squares: Array<SquareProps>) {
  const lines = [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [0, 3, 6],
    [1, 4, 7],
    [2, 5, 8],
    [0, 4, 8],
    [2, 4, 6],
  ];
  for (let i = 0; i < lines.length; i++) {
    const [a, b, c] = lines[i];
    if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
      return squares[a];
    }
  }
  return null;
}

// reducers
export const { selectSquare, restartGame } = tictactoeSlice.actions;

// selectors
export const selectSquares = (state: RootState) => state.tictactoe.squares;

export default tictactoeSlice.reducer;
